import { Typography } from 'antd';
import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Page } from 'components/molecules/page';
import { StatusUpdatesPage } from 'components/organisms/status-updates';
import { Label01, Text03 } from 'components/styles';
import { useProjectDetail } from 'data/projects/hooks';
import { useTranslation } from 'hooks/use-translation';

const Label = styled.div`
  ${Label01};
  ${Text03};
`;

const Title = styled(Page.Header.Title)`
  &&& {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const PageContent = styled(Page.Content)`
  overflow: hidden;
  padding-left: var(--spacing-05);
`;

export const ProjectStatusUpdatesPage: FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const history = useHistory();

  const { data: project } = useProjectDetail(
    ProjectId(parseInt(projectId, 10)),
  );

  return (
    <Page>
      <Page.Header
        compact
        sticky
        breadcrumbs={
          <Typography.Link onClick={() => history.goBack()}>
            {useTranslation('back')}
          </Typography.Link>
        }
        title={
          <Title>
            {useTranslation('projects.status_update')}
            <Label>{project?.projectName}</Label>
          </Title>
        }
      />
      <PageContent>
        <StatusUpdatesPage />
      </PageContent>
    </Page>
  );
};
